import { t } from '@lingui/macro';

import { Page, PageActions, PageHeader, FilterContainer, PanelContainer } from '../../page-framework';
import { StatusFilter, TimeRangeFilter } from '../../filters';
import ImpactedSitesPanel from '../../panels/impacted-sites-panel/ImpactedSitesPanel';

export const pageId = 'problem-sites';
export const pageTitle = t`Impacted Sites`;

export default function ImpactedSitesPage() {
    return (
        <Page id={pageId}>
            <PageHeader
                title={pageTitle}
                actions={
                    <PageActions pageId={pageId} pageTitle={pageTitle} reportActionOptions={{ canSchedule: false }} />
                }
            >
                <FilterContainer showSavedFilters={false}>
                    <TimeRangeFilter required />
                    <StatusFilter />
                </FilterContainer>
            </PageHeader>
            <PanelContainer>
                <ImpactedSitesPanel hideTitle flexHeight />
            </PanelContainer>
        </Page>
    );
}
